import styled from 'styled-components'
import { Text, Flex, Box } from 'vvs-uikit'

export const StepIndicatorFlex = styled(Flex)<{ withLabel: boolean }>`
  justify-content: center;
  align-items: center;
  padding-top: 15px;
  padding-bottom: ${({ withLabel }) => (withLabel ? '45px' : '15px')};
`
export const LineBetweenStep = styled(Box)<{ active: boolean }>`
  background: ${({ theme, active }) => (active ? theme.colors.primary : theme.colors.grey)};
  height: 2px;
`

export const Circle = styled(Box)<{ active: boolean }>`
  position: absolute;
  top: -15px;
  left: -15px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: ${({ theme, active }) => (active ? theme.colors.primary : theme.colors.grey)};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => (theme.isDark ? 'black' : 'white')};
`
export const StepLabel = styled(Text)<{ active: boolean }>`
  position: absolute;
  transform: translate(-50%, 0);
  white-space: nowrap;
  padding-top: 25px;
  ${({ active, theme }) =>
    active &&
    `
    color: ${theme.colors.primary};
    text-decoration: underline;
  `}
`

export const StepDotDiv = styled.div<{ active: boolean }>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  cursor: pointer;

  ${({ active, theme }) =>
    active
      ? `
    background: ${theme.colors.primary};
  `
      : `
    border: 3px solid ${theme.colors.lightNightBlue};
  `}
`
